import Config from '../Config.tsx';
import {chatBubble} from '../utilities/chatBubble/chatBubble';
import '../utilities/chatBubble/chatBubble.scss';

//import chatBubble from '../utilities/chatBubble.js';
export default () => (next) => (action) => {
  if (action.type === 'ADD_UPDATE_ICONTENT_ITEM') {
    try {
      var chatBubbleItem = new chatBubble(10, 10);
      if (action?.item?.hideChatBox?.value || Config.defaultChatBubbleGroup?.value != '') {
        var currentChatBubbleGroupList = action?.item?.chatBubbleGroupItem;
        var defaultChatBubbleGroupList = Config.defaultChatBubbleGroup;
        if (currentChatBubbleGroupList === undefined && window.location.pathname != '/') {
          return next(action);
        }
        var chatBubbleListEpi;
        var hideChatBox = false;
        var chatBubbleBtn = document.getElementById('chatBubbleBtn');

        if (currentChatBubbleGroupList?.expandedValue?.length > 0) {
          chatBubbleListEpi = currentChatBubbleGroupList.expandedValue[0].chatBubbleList.expandedValue;
        } else {
          defaultChatBubbleGroupList = JSON.parse(defaultChatBubbleGroupList);
          chatBubbleListEpi = defaultChatBubbleGroupList.expandedValue[0].chatBubbleList.expandedValue;
        }
        hideChatBox =
          Config.hideChatBox == 'True' ||
          action?.item?.hideChatBox.value == true ||
          action?.item?.url?.includes('/selfcare/lobbyPage') ||
          action?.path?.includes('/selfcare/lobbyPage')
            ? true
            : false; //אזור אישי חדש--"/selfcare/lobbyPage"
        chatBubbleItem.buildMainBtn(chatBubbleListEpi, chatBubbleBtn, hideChatBox);
        chatBubbleItem.buildItemChatBubbleUp(chatBubbleListEpi, chatBubbleBtn);
      }
    } catch (err) {
      console.error(err);
    }
  } else if (action.type == 'UPDATE_PATH') {
    try {
      if (action?.path) {
        // var content = EpiContext.getContentByPath(action.path);
        // if (content?.hideChatBox?.value === true) {
        // } else {
        // }
      }
    } catch (err) {
      console.error(err);
    }
  }

  return next(action);
};
